import { render, staticRenderFns } from "./ShopNews.vue?vue&type=template&id=3a185107&scoped=true&"
import script from "./ShopNews.vue?vue&type=script&lang=js&"
export * from "./ShopNews.vue?vue&type=script&lang=js&"
import style0 from "./ShopNews.vue?vue&type=style&index=0&id=3a185107&lang=scss&scoped=true&"
import style1 from "./ShopNews.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a185107",
  null
  
)

export default component.exports